import { useState } from "react";
import { Outlet } from "react-router-dom";

import { GlobalFetchingIndicator } from "@/components/layout/GlobalFetchingIndicator";
import { OfflineBanner } from "@/components/layout/OfflineBanner";

import { PlatformHeader } from "./PlatformHeader";
import { PlatformSidebar } from "./PlatformSidebar";

export function PlatformLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-100">
      <GlobalFetchingIndicator />
      <OfflineBanner />

      <div className="flex min-h-screen">
        <div className="hidden lg:block">
          <PlatformSidebar />
        </div>

        {sidebarOpen && (
          <div className="fixed inset-0 z-50 lg:hidden">
            <button
              type="button"
              aria-label="Close platform navigation"
              onClick={() => setSidebarOpen(false)}
              className="absolute inset-0 bg-slate-950/60"
            />

            <div className="relative h-full w-72 shadow-2xl">
              <PlatformSidebar />
            </div>
          </div>
        )}

        <main className="min-w-0 flex-1">
          <PlatformHeader
            onToggleSidebar={() =>
              setSidebarOpen((current) => !current)
            }
          />

          <div className="px-6 py-6 lg:px-8 lg:py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
